import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Server } from "lucide-react";

function StatusPill({ status }) {
  const map = {
    running: ["bg-emerald-500/20 text-emerald-400 border-emerald-500/30", "● online"],
    provisioning: ["bg-amber-500/20 text-amber-400 border-amber-500/30", "◐ provisionando"],
    stopped: ["bg-red-500/20 text-red-400 border-red-500/30", "○ parada"],
    suspended: ["bg-red-500/20 text-red-400 border-red-500/30", "! suspensa"],
    terminated: ["bg-zinc-500/20 text-zinc-400 border-zinc-500/30", "× encerrada"],
  };
  const [cls, label] = map[status] || map.terminated;
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-sm border font-mono text-xs uppercase ${cls}`}>{label}</span>;
}

export default function VpsList() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/vps").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-8" data-testid="vps-list-page">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-2">// vps</div>
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tighter">Minhas VPS</h1>
      </div>

      <div className="border border-white/10 bg-[#121214]">
        {items.length === 0 ? (
          <div className="p-10 text-center">
            <Server className="h-8 w-8 mx-auto text-zinc-600 mb-3" />
            <div className="text-zinc-500">Nenhuma VPS ainda. <Link to="/#planos" className="text-white underline">Escolher um plano</Link></div>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="text-xs font-mono uppercase tracking-widest text-zinc-500">
              <tr className="border-b border-white/10">
                <th className="text-left px-5 py-3">Hostname</th>
                <th className="text-left px-5 py-3">IP</th>
                <th className="text-left px-5 py-3">Specs</th>
                <th className="text-left px-5 py-3">SO</th>
                <th className="text-left px-5 py-3">Localização</th>
                <th className="text-left px-5 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((v) => (
                <tr key={v.vps_id} className="border-b border-white/5 hover:bg-white/5" data-testid={`vps-list-row-${v.vps_id}`}>
                  <td className="px-5 py-3 font-mono">
                    <Link to={`/dashboard/vps/${v.vps_id}`} className="hover:underline">{v.hostname}</Link>
                  </td>
                  <td className="px-5 py-3 font-mono">{v.ipv4}</td>
                  <td className="px-5 py-3 font-mono text-xs">{v.cpu_cores}vCPU · {v.ram_gb}GB · {v.ssd_gb}GB</td>
                  <td className="px-5 py-3 text-xs">{v.os}</td>
                  <td className="px-5 py-3">{v.location}</td>
                  <td className="px-5 py-3"><StatusPill status={v.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
